import React from "react";

const Notification = ({ show, type, message, onClose }) => {
  if (!show) return null;

  return (
    <div className={`notification notification--${type}`}>
      <span className="notification__message">{message}</span>
      <button className="notification__close" onClick={onClose}>
        &times;
      </button>
    </div>
  );
};

export default Notification;
